/* Keep wrapping colour choices visible while aligning actions across each product group. */
(() => {
  const start = () => {
    const root = document.getElementById('MainContent');
    if (!root) return;
    let scheduled = false;
    const watched = new Set();
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(update);
    };
    const observer = new ResizeObserver(schedule);
    const update = () => {
      scheduled = false;
      for (const el of watched) {
        if (!el.isConnected) { observer.unobserve(el); watched.delete(el); }
      }
      const groups = new Map();
      root.querySelectorAll('.cabane-product-card').forEach(card => {
        const group = card.closest('.product-grid') || card.parentElement;
        if (!group) return;
        if (!groups.has(group)) groups.set(group, 0);
        const colors = card.querySelector('.cabane-colors');
        if (!colors) return;
        if (!watched.has(colors)) { watched.add(colors); observer.observe(colors); }
        groups.set(group, Math.max(groups.get(group), Math.ceil(colors.getBoundingClientRect().height)));
      });
      groups.forEach((height, group) => {
        const value = height + 'px';
        if (group.style.getPropertyValue('--cabane-colors-row-height') !== value)
          group.style.setProperty('--cabane-colors-row-height', value);
      });
    };
    new MutationObserver(schedule).observe(root, {childList:true, subtree:true});
    window.addEventListener('resize', schedule, {passive:true});
    document.addEventListener('shopify:section:load', schedule);
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
